import { useEffect } from 'react';
import { auth } from '../api/axios';
import { isOfflineSyncConfigured, startOfflineSync } from './session';

/** Starts/targets the sync session for the signed-in company and re-syncs when the tab becomes visible. */
export function useOfflineSyncSession(): void {
  useEffect(() => {
    if (!isOfflineSyncConfigured()) return;

    const sync = () => {
      const companyId = auth.getCompanyId();
      if (companyId) void startOfflineSync(companyId);
    };
    sync();

    const onVisible = () => {
      if (document.visibilityState === 'visible') sync();
    };
    document.addEventListener('visibilitychange', onVisible);
    return () => document.removeEventListener('visibilitychange', onVisible);
  }, []);
}
